<template>
    <wrapper-features-templates-one-column
    :hideWhiteBoxOnLoad="showLoader"
    :noWhiteBox="applyErrorState"
    :showLoader="showLoader"
    :applyErrorState="applyErrorState"
    @backOrCloseClicked="emit('backOrCloseClicked')">
        <transition name="common-enter-animation" mode="out-in" appear>
            <div v-if="!showLoader && !applyErrorState" class="information-wrapper">
                <!-- Personal Info -->
                <personal-info :personalData="getCustomerInfo.personalData"/>
                <!-- QR Code Info -->
                <qr-code-info/>
                <!-- Identification Info -->
                <identification-info :identificationData="getCustomerInfo.identificationData"/>
                <!-- Taxation Info -->
                <taxation-info :taxationData="getCustomerInfo.fiscalDocument"/>
                <!-- Professional Activity Info -->
                <professional-activity-info :professionalData="getCustomerInfo.jobActivity"/>
            </div>
		</transition>
    </wrapper-features-templates-one-column>
    <!-- Feedback Toasts -->
    <toast-generic
	v-if="showFeedbackToast"
	:toastType="feedbackToastData.toastType"
	:feedbackText="feedbackToastData.text"
	:buttonsParams="feedbackToastData.buttons"
	@hideMe="showFeedbackToast = false"/>
</template>

<script setup>
import WrapperFeaturesTemplatesOneColumn from '@/components/wrappers/featuresTemplates/OneColumn'
import PersonalInfo from '@/components/features/userArea/profile/PersonalInfo'
import QrCodeInfo from '@/components/features/userArea/profile/QRCodeInfo'
import IdentificationInfo from '@/components/features/userArea/profile/IdentificationInfo'
import TaxationInfo from '@/components/features/userArea/profile/TaxationInfo'
import ProfessionalActivityInfo from '@/components/features/userArea/profile/ProfessionalActivityInfo'
import ToastGeneric from '@/components/generic/toasts/Generic'

/* Assets & Helpers */
import { ref } from 'vue'
import { errorObjectConstructor, emptyObjectConstructor } from '@/assets/scripts/toastsHelpers'

/* Store */
import { mapActions, mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'
import { cancelAllPendingRequests } from '@/store/helpers/accessControl'

/* mapActions & mapGetters */
const { requestCustomerInfo } = mapActions(moduleMapper.USER_AREA_PROFILE)
const { getCustomerInfo } = mapGetters(moduleMapper.USER_AREA_PROFILE)

/* Emmitters */
const emit = defineEmits(['backOrCloseClicked'])

/* Data */
const showLoader = ref(false)
const applyErrorState = ref(false)

/*************************************************
*                                                *
*                 Requests Logic                 *
*                                                *
*************************************************/

const fetchProfileInfo = async () => {
	showLoader.value = true
	applyErrorState.value = false
	showFeedbackToast.value = false
	cancelAllPendingRequests()
	try {
        await requestCustomerInfo()
        showLoader.value = false
	} catch (error) {
		if (error.toString() === 'Cancel') return
		showLoader.value = false
		applyErrorState.value = true
		errorHandler(error.response.data, fetchProfileInfo)
	}
}

/*************************************************
*                                                *
*                 Error Handler                  *
*                                                *
*************************************************/
const showFeedbackToast = ref(false)
const feedbackToastData = ref(emptyObjectConstructor())

const errorHandler = (data, retryFn) => {
	feedbackToastData.value = errorObjectConstructor(data, retryFn)
	showFeedbackToast.value = true
}

fetchProfileInfo()
</script>

<style lang="scss" scoped>
.information-wrapper {
    width: 100%;

	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>
